import { ProductsQuery } from './products-query';
import { ProductCategoriesQuery } from './product-categories-query';
export var endpoints = {
    productsQuery: new ProductsQuery(),
    productCategoriesQuery: new ProductCategoriesQuery(),
};
